export default () => ({
  mobileMenuOpen: false,
  isScrolled: false,
  scrollHandler: null,
  desktopQuery: null,
  resizeHandler: null,

  init() {
    this.scrollHandler = () => this.handleScroll();
    this.handleScroll();
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
    this.desktopQuery = window.matchMedia('(min-width: 1280px)');
    this.resizeHandler = () => {
      if (this.desktopQuery.matches) this.mobileMenuOpen = false;
    };
    this.desktopQuery.addEventListener('change', this.resizeHandler);
    this.$watch('mobileMenuOpen', (value) => {
      document.documentElement.classList.toggle('overflow-hidden', value);
      document.body.classList.toggle('overflow-hidden', value);
    });
  },

  handleScroll() {
    this.isScrolled = window.scrollY > 16;
  },

  closeMobileMenuIfNeeded() {
    if (!this.mobileMenuOpen) {
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }
  },

  destroy() {
    window.removeEventListener('scroll', this.scrollHandler);
    this.desktopQuery?.removeEventListener('change', this.resizeHandler);
    if (this.mobileMenuOpen) {
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }
  },
});